import React from "react";
import { UserContext } from "../contexts";
import UserForm from "../pages/user-form.component";
import { UserFormProvider } from "../providers";
import UserToolbar from "./user-toolbar.component";

function CompanyFormPanel(): JSX.Element {
  const { user } = React.useContext(UserContext);

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <UserFormProvider initialData={user}>
      <UserToolbar />
      <UserForm />
    </UserFormProvider>
  );
}

export default CompanyFormPanel;
